// extracted by mini-css-extract-plugin
module.exports =  {"drawerCarbon":"drawerCarbon_uu3WJDYS","sidebarContainer":"sidebarContainer_H8VDh1Vy","iconButtonContainer":"iconButtonContainer_hx71JD6_"};